import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment, useState } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl, TextControl, ToggleControl, RangeControl, Flex, FlexBlock, FlexItem, ColorPicker, ColorPalette } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;


wp.blocks.registerBlockVariation('core/paragraph', {
    name: "progressbar",
    title: 'Progressbar',
    keywords: [ "progress", "bar", "count", "stats" ],
    icon: 'chart-bar',
    isDefault: false,
    category: "text",
    scope: [ "inserter", "transform", "block" ],
    description: "Show  progress bar.",

    attributes: {
        className: "is-sp-progressbar",
        backgroundColor: "#999999",
        spacing: { padding: { right: "0", left: "0", top: "0", bottom: "0" } },
        layout: { type: "flex", flexWrap: "nowrap", orientation: "marquee", justifyContent: "left" },
    },

    allowedBlocks: [ [ 'core/paragraph' ] ],
    innerBlocks: [
        {
            name: "core/paragraph",
            attributes: {
                content: "Marketing",
                gradient: 'luminous-vivid-amber-to-luminous-vivid-orange',
                textColor: '#fff',
                spacing: { padding: { right: "10", left: "10", top: "10", bottom: "10" } },
            }
        }
    ],
    example: {
        innerBlocks: [
            {
                name: "core/paragraph",
                attributes: {
                    content: "Marketing",
                }
            }

        ]
    },
    isActive: (e) => {
        if (e.className && e.className.includes('is-sp-progressbar')) {
            return true;
        }
        return false;
    },

});


// Enable spacing control on the following blocks
const enableCounterControlOnBlocks = [
    'core/paragraph',
];

const progressBarOptions = [
    {
        label: __('Line'),
        value: 'line',
    },
    {
        label: __('Half Circel'),
        value: 'half-circle',
    }
];

const progressStyleOption = [
    {
        label: __('Style 1'),
        value: 'style1',
    },
    {
        label: __('Style 2'),
        value: 'style2',
    }
];


/**
 * Add spacing control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */
const addProgressBarControlAttribute = (settings, name) => {
    // Do nothing if it's another block than our defined ones.
    if (!enableCounterControlOnBlocks.includes(name)) {
        return settings;
    }

    // Use Lodash's assign to gracefully handle if attributes are undefined
    settings.attributes = assign(settings.attributes, {

        progressbarLayout: {
            type: 'string',
            default: 'line'
        },
        progressbarStyle: {
            type: 'string',
            default: 'style1'
        },

        progressValue: {
            type: 'number',
            default: 10
        },
        progressTitle: {
            type: 'string',
            default: 'Progressbar'
        },

        progressStartLabel: {
            type: 'string',
            default: 'Start'
        },

        progressEndLabel: {
            type: 'string',
            default: 'End'
        },
        progressColor: {
            type: "string",
            default: "#cccc"
        },
        progressTextColor: {
            type: "string",
            default: "#fff"
        },
        progressCircleSize: {
            type: "number",
            default: 20
        }
    });

    return settings;
};

addFilter('blocks.registerBlockType', 'extend-block-example/progressbar/data', addProgressBarControlAttribute);







/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const progressBarControl = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { setAttributes, attributes, clientId } = props;
        const { progressTextColor, progressColor } = attributes
        // console.log(props);
        // Do nothing if it's another block than our defined ones.
        if (!enableCounterControlOnBlocks.includes(props.name)) {
            return (
                <BlockEdit { ...props } />
            );
        }
        if (!(props.attributes.className && props.attributes.className.includes('is-sp-progressbar'))) {
            return (
                <BlockEdit { ...props } />
            )
        }


        const setValueAttr = (val) => {
            try {
                document.getElementById(clientId).setAttribute("style",
                    "--progress-percent: " + val + "; \
                    --progress-circle-diameter: " + props.attributes.progressCircleSize + "rem;\
                    --progress-blue:" + props.attributes.progressColor + "; \
                    --progress-text-color:" + props.attributes.progressTextColor + ";"
                );
            } catch (e) {

            }
        }

        setValueAttr(props.attributes.progressValue);

        return (
            <Fragment>
                <div className={ "is-sp-progressbar-wrapper layout-" + props.attributes.progressbarLayout } { ...props }

                >
                    <BlockEdit  { ...props } />


                    { props.attributes.progressbarLayout !== 'line' &&

                        <div { ...props }>
                            <div className="sp-progress" id={ clientId }>
                                <div className="bar-overflow">
                                    <div className="bar" data-percent={ props.attributes.progressValue }

                                    ></div>
                                </div>

                                <div className="info"

                                >
                                    <h2 className="number" id="number" data-number={ props.attributes.progressValue } data-display={ props.attributes.progressValue + "%" }></h2>
                                    <p>{ props.attributes.progressTitle }</p>
                                    <div class="info-arrow"></div>
                                </div>
                                <div className="min-max">
                                    <span>{ props.attributes.progressStartLabel }</span>
                                    <span>{ props.attributes.progressEndLabel }</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <InspectorControls>
                    <PanelBody
                        title={ __('Progressbar Settings') }
                        initialOpen={ true }
                    >
                        <SelectControl
                            label={ __('Layout') }
                            value={ props.attributes.progressbarLayout }
                            options={ progressBarOptions }
                            onChange={ (val) => {
                                props.setAttributes({
                                    progressbarLayout: val,
                                });
                            } }
                        />

                        <RangeControl
                            type="number"
                            label={ __("Counter Value", 'sparkle-blocks') }
                            description="Value is in %"
                            min={ 1 }
                            max={ 100 }
                            step={ 1 }
                            value={ props.attributes.progressValue }
                            onChange={ (val) => { setAttributes({ progressValue: val }); setValueAttr(val) } }
                        />

                        { props.attributes.progressbarLayout != 'line' &&
                            <Fragment>
                                <TextControl
                                    type="text"
                                    label={ __("Title", 'sparkle-blocks') }
                                    placeholder="Progressbar"
                                    value={ props.attributes.progressTitle }
                                    onChange={ (val) => setAttributes({ progressTitle: val }) }
                                />


                                <TextControl
                                    type="text"
                                    label={ __("Start Label", 'sparkle-blocks') }
                                    placeholder="Start label"
                                    value={ props.attributes.progressStartLabel }
                                    onChange={ (val) => setAttributes({ progressStartLabel: val }) }
                                />

                                <TextControl
                                    type="text"
                                    label={ __("End Label", 'sparkle-blocks') }
                                    placeholder="End label"
                                    value={ props.attributes.progressEndLabel }
                                    onChange={ (val) => setAttributes({ progressEndLabel: val }) }
                                />

                                <RangeControl
                                    type="number"
                                    label={ __("Circle Size", 'sparkle-blocks') }
                                    description="Value is rem"
                                    min={ 1 }
                                    max={ 100 }
                                    step={ 5 }
                                    value={ props.attributes.progressCircleSize }
                                    onChange={ (val) => { setAttributes({ progressCircleSize: val }) } }
                                />


                                <PanelBody
                                    title={ __('Text Color Settings') }
                                    initialOpen={ false }
                                >
                                    <ColorPicker
                                        label={ __("Text Color", 'sparkle-blocks') }
                                        color={ props.attributes.progressTextColor }
                                        onChange={ (val) => setAttributes({ progressTextColor: val }) }
                                        enableAlpha
                                        defaultValue="#000"
                                    />
                                </PanelBody>

                                <PanelBody
                                    title={ __('Background Settings') }
                                    initialOpen={ false }
                                >

                                    <ColorPicker
                                        label={ __("Background Color", 'sparkle-blocks') }
                                        color={ props.attributes.progressColor }
                                        onChange={ (val) => setAttributes({ progressColor: val }) }
                                        enableAlpha
                                        defaultValue="#cccc"
                                    />
                                </PanelBody>
                            </Fragment>
                        }

                        { props.attributes.progressbarLayout == 'line' &&
                            <SelectControl
                                label={ __('Style') }
                                value={ props.attributes.progressbarStyle }
                                options={ progressStyleOption }
                                onChange={ (val) => {
                                    props.setAttributes({
                                        progressbarStyle: val,
                                    });
                                } }
                            />
                        }

                    </PanelBody>
                </InspectorControls>
            </Fragment >
        );
    };
}, 'progressBarControl');

addFilter('editor.BlockEdit', 'extend-block-example/with-counter-control', progressBarControl);